import React, { useMemo, useState } from 'react';
import {
  IGenericMapAction,
  GenericMapActionInput,
  IGenericMapExecutedAction,
} from '../../../models/SmartMapActions.model';
import { Formik } from 'formik';
import { Form, Modal, Button } from 'react-bootstrap';
import { debounceEventHandler } from '../../shared/submitFormUtility';
import TextField from '../../shared/formikFields/TextField';
import Select from 'react-select';
import { Spinner2 } from '../../shared/spinner2';
import { SmartMapActionsService } from '../../../services/smartMapActionsService';
import { Toastr } from '../../../utils/Toastr';

export interface ISmartMapActionModalProps {
  show: boolean;
  onHide: (rerender: boolean) => void;
  action: IGenericMapAction;
  selectedElements: any;
  isLoading: boolean;
  agreementIds: Array<number>;
}

export default function SmartMapActionModal(
  props: ISmartMapActionModalProps
): JSX.Element {
  const action = props.action;
  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (values: IGenericMapAction): Promise<void> => {
    setIsLoading(true);
    if (selectedOption) {
      values.options = [
        {
          key: selectedOption.value,
          value: selectedOption.label,
        },
      ];
    }
    const executedAction: IGenericMapExecutedAction = {
      agreementIds: props.agreementIds,
      formContent: JSON.stringify(values),
      typeId: props.action.typeId,
    };
    try {
      await SmartMapActionsService.executeAction(executedAction);
      Toastr.success('Success');
    } catch (error) {
      Toastr.error('Something went wrong', true);
    } finally {
      setIsLoading(false);
      props.onHide(true);
    }
  };

  const selectOptions = useMemo(() => {
    return (
      props.action?.options?.map((opt: any) => ({
        value: opt.key ?? opt.Key ?? opt[0],
        label: opt.value ?? opt.Value ?? opt[1],
      })) ?? []
    );
  }, [props.action]);

  const getTemplate = () => {
    switch (props.action?.inputType) {
      case GenericMapActionInput.SELECT:
        return SendDropdownTemplate();
      case GenericMapActionInput.TEXT:
        return SendTextTemplate();
      default:
        return <></>;
    }
  };

  const SendTextTemplate = () => {
    return (
      <TextField label={action.inputLabel} name="template" placeholder="" />
    );
  };

  const SendDropdownTemplate = () => {
    return (
      <>
        <label>{action.inputLabel}</label>
        <Select
          options={selectOptions}
          value={selectedOption}
          onChange={setSelectedOption}
        />
      </>
    );
  };

  if (!props.action) return null;

  return (
    <Formik key={props.action?.id} onSubmit={onSubmit} initialValues={action}>
      {({ handleSubmit }) => (
        <Modal
          show={props.show}
          onHide={() => props.onHide(false)}
          className="user-edit-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{props.action?.actionName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Spinner2 show={props.isLoading || isLoading} />
            <Form noValidate onSubmit={handleSubmit}>
              {getTemplate()}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => props.onHide(false)}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              onClick={debounceEventHandler(handleSubmit, 250)}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Formik>
  );
}
